module.exports = __webpack_public_path__ + "img/visuel-tarif-hub.4b017d9e.jpg";